import axios from 'axios'
import store from '@/Store'
import VueApp from '@/main.js'
import ConfiguradorApi from '@/api/ConfiguradorApi'
import CartaoVirtualApi from '@/views/3/CartaoVirtualApi'
import PlataformaBeneficiarioApi from '@/api/PlataformaBeneficiarioApi'
import MosiaChatApi from '@/api/MosiaChatApi'
import LogApi from './api/LogApi'
import OmniChatApi from '@/api/OmniChatApi'
import UtilitariosApi from '@/api/UtilitariosApi'
import ChatApi from '@/api/ChatApi'
import OmniMeetingApi from '@/api/OmniMeetingApi'

// Midleweres
const API = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API
})
API.interceptors.request.use((config) => {
  // Case já preenchido. Não sobrescrever.
  if (!config.headers.Authorization && !config.headers.authorization) {
    const token = store.getters['Login/token']
    if (token) {
      config.headers.Authorization = token
    }
  }

  return config
}, (err) => Promise.reject(err))

API.interceptors.response.use((response) => {
  store.dispatch('ErrorStore/clean')

  return response.data
}, (error) => {
  const message = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : 'Falha ao realizar requisição. Por favor tente novamente.'

  return {
    status: false,
    code: (error.response || {}).status,
    message,
    data: (error.response && error.response.data) ? error.response.data : null
  }
})

API.defaultOptions = {
  notifySuccess: false,
  notifyFailure: false,
  handlerErrorIgnore: false
}

const mergeOptions = (options) => {
  return { ...API.defaultOptions, ...options }
}

API.notifyRequest = async (request, options) => {
  const opt = mergeOptions(options)
  const result = await request

  if (!result.status) {
    if (result.code === 401) {
      const payload = {
        origin: 'omnichannel',
        client: store.state.SetupApp.frameId,
        type: 'command',
        command: 'LOGOUT',
        data: { expirado: true },
        timestamp: Date.now()
      }

      window.parent.postMessage(payload, '*')
    }

    if (!opt.handlerErrorIgnore) {
      store.dispatch('ErrorStore/setRequestData', result)
    } else if (Array.isArray(opt.handlerErrorIgnore) && opt.handlerErrorIgnore.indexOf(result.code) === -1) {
      store.dispatch('ErrorStore/setRequestData', result)
    }

    if (opt.notifyFailure) {
      const message = result.message ? result.message : 'Falha ao realizar requisiçao. Por favor tente novamente mais tarde'
      VueApp.$notify.error({
        title: 'Erro!',
        dangerouslyUseHTMLString: true,
        message: `${message} <br><small>${VueApp.$moment(new Date()).format('DD/MM/YYYY HH:mm:ss')}</small>`,
        showClose: false,
        position: 'top-right',
        duration: 2000,
        customClass: `el-notification-error`
      })
    }

    return result
  } else {
    if (opt.notifySuccess) {
      VueApp.$notify.success({
        title: 'Sucesso!',
        dangerouslyUseHTMLString: true,
        message: `${result.message} <br><small>${VueApp.$moment(new Date()).format('DD/MM/YYYY HH:mm:ss')}</small>`,
        showClose: false,
        position: 'top-right',
        duration: 2000,
        customClass: `el-notification-success`
      })
    }

    return result
  }
}

export const axiosAPI = API
export const ConfiguradorResource = ConfiguradorApi(API)
export const CartaoVirtualResource = CartaoVirtualApi(API)
export const PlataformaBeneficiarioResource = PlataformaBeneficiarioApi(API)
export const MosiaChatResource = MosiaChatApi(API)
export const LogResource = LogApi(API)
export const ChatApiResource = OmniChatApi(API)
export const UtilitarioResource = UtilitariosApi(API)
export const ChatResource = ChatApi(API)
export const OmniMeetingResource = OmniMeetingApi(API)
